import 'intersection-observer';
import {statistics} from '@js/config/index'; // 数据埋点

export default class Exposure {
  constructor(fn) {
    this._observer = null;
    this.init(fn);
  }

  /**
   * 初始化
   */
  init(fn) {
    // 实例化监听
    this._observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          // 出现在视窗中
          entry = entry || entries[0];
          if (entry.isIntersecting) {
            // 获取参数
            const pointName = entry.target.attributes['point-name'] && entry.target.attributes['point-name'].value;
            let params = entry.target.attributes['point-params'] && entry.target.attributes['point-params'].value;
            try {
              params = JSON.parse(params);
            } catch (e) {}
            this.addPoint(pointName, params);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5 // 元素出现面积，0 - 1，这里当元素出现一半以上则进行曝光
      }
    );
  }

  add(el) {
    this._observer && this._observer.observe(el);
  }

  addPoint(pointName, params) {
    if (pointName === 'cepingjieguo_gengduo_s') {
      // 更多测评埋点
      pointName && statistics.moreAssessTrackPoint(pointName, params);
      return;
    }
    pointName && statistics.trackPoint(pointName, params);
  }
}



// WEBPACK FOOTER //
// ./src/directive/addExposurePoint/exposure.js